module.exports = __webpack_public_path__ + "static/favicon-397a68bb193b9b19fd147baa309a728e.png";